import React from "react";

const CheckboxLabelPosition = {
  Right: "right",
  Left: "left",
};

const labelClasses = "mb-0! flex items-center gap-2 cursor-pointer";
const inputClasses = "w-4 h-4 rounded-xs border border-primary bg-white accent-primary cursor-pointer";

const Checkbox1 = ({ label, position, ...restProps }) => {
  const isRight = position === CheckboxLabelPosition.Right;
  return (
    <div className="form-field" key={restProps?.key}>
      <div className={`form-field${isRight ? ' cs-right' : ''}`}>
        <label className={`${labelClasses}${isRight ? ' flex-row-reverse' : ''}`}>
          <CheckboxControl {...restProps} />
          {label}
        </label>
      </div>
    </div>
  );
};

const CheckboxControl = ({ field, disabled, ...restProps }) => {
  const onCheckboxClick = (e) => {
    if (restProps?.onClick) {
      restProps.onClick(e);
    }
  };

  return (
    <input
      {...field}
      disabled={disabled}
      onClick={onCheckboxClick}
      className={inputClasses}
      type="checkbox"
      checked={restProps?.checked || field.value}
    />
  );
};

Checkbox1.defaultProps = {
  label: "Checkbox",
  position: "left",
};

export default Checkbox1;
